(function($){
    $(function(){
        var $sectionNav = $('#zn-section-nav');

        if (!$sectionNav.length){
            return;
        }

        var $secNavSticky = $sectionNav.clone().attr('id', 'zn-section-nav-sticky').attr('aria-label', 'Acadia Features Page Sections Sticky').prependTo($('body')),
            $navLinks = $secNavSticky.find('.zn-section-nav-links-container'),
            $navToggle = $('<div class="zn-section-nav-toggle"><span>Acadia Features</span></div>').prependTo($secNavSticky),
            openClass = 'zn-menu-active',
            mobileSetup = false, //because build/destroy nav is accessed in both breakdance and scrollpast, we have a race condition. Need this bool to prevent conflicts. This bool should only be changed in the build/destroy functions for mobile menu to prevent race condition #2
            $doc = $(document),
            //Close Mobile Nav
            closeNav = function closeNav(){
                $secNavSticky.removeClass(openClass);
                $navToggle.removeAttr('aria-expanded').focus();
                $doc.off('keydown.secNavKeys').off('click.secNavClose');
            },
            //Open Mobile Nav
            openNav = function openSecNav(){
                $navToggle.attr('aria-expanded', 'true');
                $secNavSticky.addClass(openClass);

                setTimeout(function(){
                    $navLinks.find('a').eq(0).focus();
                }, 0);

                $doc.on('keydown.secNavKeys', function(e){
                    var keyCode = e.which;
                    if(keyCode === 27){
                        closeNav();
                    }
                }).on('click.secNavClose', function(){
                    closeNav();
                });
            },
            //Set up Navigation
            buildSecNav = function buildSecNav(){
                mobileSetup = true;
                $navToggle.addAccess().on('click.secNavToggle', function(e){
                    e.stopPropagation();
        
                    if($secNavSticky.hasClass(openClass)){
                        closeNav();
                    } else {
                        openNav();
                    }
                });

                $secNavSticky.on('click.secNavClick', function(e){
                    e.stopPropagation();
                });
            },
            //Tear down navigation
            destroySecNav = function destroySecNav(){
                mobileSetup = false;
                closeNav($navToggle, openClass);
                $secNavSticky.off('click.secNavClick');
                $navToggle.removeAccess().off('click.secNavToggle');
                $(document.activeElement).blur();
            };

        /****************** Detect if scrolled past original navigation to set up sticky nav *********************/
        $sectionNav.scrollPast({scrollClass: 'zn-sticky-is-active'}, function(){
            if (!mobileSetup){
                buildSecNav();  // Called after scrolled past
            }
            $secNavSticky.addClass('zn-active');

        }, function(){
            if (mobileSetup){
                destroySecNav(); // Called if scrolled back up
            }
            $secNavSticky.removeClass('zn-active');
        });  

        /****************** Breakdance to setup mobile nav when changing screen sizes*********************/
        var secNavBreaks = [
            {
                min: 0, 
                max: 1023,
                enter: function(){
                    if (!mobileSetup){
                        buildSecNav();
                    }
                },
                exit: function(){
                    if (mobileSetup){
                        destroySecNav();
                    }
                }
            }
        ];
    
        breakdance(secNavBreaks);

        /***************************** Animate Scroll *********************************/
        var $secNavLinks = $('.zn-section-nav-link');
  
        if ($secNavLinks.length){
            $secNavLinks.animateScroll({
                offset: [
                    {
                        minWidth: 1,
                        maxWidth: 1023,
                        offsetSize: -100
                    }
                ]
            });
            $secNavLinks.on('click', function(){
                if (mobileSetup){
                    closeNav();  
                }
            });
        }

    });
})($JQ);

